<template>
  <div class="com-table">
    <div class="table-head row">
      <div
        v-for="item in tableColumns"
        :key="item.prop"
        class="cell"
        :style="{ width: getWidth(item) }"
      >
        {{ item.label }}
        <div v-if="item.sort" class="sort">
          <div class="up" :class="{ active: item.sort === 'esc' }" @click="changeSort(item, 'esc')"></div>
          <div class="down" :class="{ active: item.sort === 'desc' }" @click="changeSort(item, 'desc')"></div>
        </div>
      </div>
    </div>
    <div class="table-body">
      <el-scrollbar
        style="width: 100%; height: 100%"
        wrap-style="overflow-x: hidden;"
      >
<!--        <AutoScroll :height="101" :step="scrollStep" :counts="data.length" :duation="3000">-->
          <div
            v-for="(row, i) in tableData"
            :key="i"
            class="table-body-row row"
            @click="$emit('clickRow', row)"
          >
            <div
              v-for="item in tableColumns"
              :key="item.prop"
              class="cell"
              :style="{ width: getWidth(item) }"
            >
              <template v-if="item.slot">
                <slot :name="item.slot" :data="row" :index="i"></slot>
              </template>
              <template v-else>
                {{ row[item.prop] }}
              </template>
            </div>
          </div>
<!--        </AutoScroll>-->
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
// import AutoScroll from "@/components/AutoScroll/index"
  export default {
    // components: { AutoScroll },
    props: {
      columns: { type: Array, default: () => [] },
      data: { type: Array, default: () => [] },
      scrollStep: { type: Number, default: 35 }
    },
    data() {
      return {
        tableColumns: [],
        tableData: []
      };
    },
    mounted() {
      this.tableColumns = this.columns
      this.tableData = JSON.parse(JSON.stringify(this.data))
    },
    watch: {
      data() {
        this.tableData = JSON.parse(JSON.stringify(this.data))
      }
    },
    computed: {},
    methods: {
      getWidth(item) {
        const every = Math.round((10 / this.columns.length) * 100) / 10;
        if (!item.width) return `${every}%`;
        if (/^[0-9]*$/.test(item.width)) return `${item.width}px`;
        return item.width;
      },
      changeSort (item, type) {
        if (item.sort === type) {
          item.sort = true
          return this.tableData = JSON.parse(JSON.stringify(this.data))
        }
        this.tableColumns.map(x => {
          if (x.sort) return x.sort = true
        })
        item.sort = type
        if (type === 'esc') {
          this.tableData.sort((x, y) => {
            return x[item.prop] - y[item.prop]
          })
        } else {
          this.tableData.sort((x, y) => {
            return y[item.prop] - x[item.prop]
          })
        }
      }
    },
  };
</script>

<style scoped lang="less">
  @table-head-height: 35px;
  .text-over1 {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .com-table {
    width: 100%;
    height: 100%;
    font-size: 16px;

    .table-head {
      height: @table-head-height;
      background: rgba(0, 178, 255, 0.3);
      .sort{
        display: inline-block;
        cursor: pointer;
        .up.active{
          border-bottom: #409eff 5px solid;
        }
        .down.active{
          border-top: #409eff 5px solid;
        }
        .up{
          width: 0px;
          height: 0px;
          border-bottom: #ffffff 5px solid;
          border-left: transparent 4px solid;
          border-right: transparent 4px solid;
          margin-bottom: 2px;
        }
        .down{
          width: 0px;
          height: 0px;
          border-top: #ffffff 5px solid;
          border-left: transparent 4px solid;
          border-right: transparent 4px solid;
          margin-top: 2px;
        }
      }
    }

    .table-body {
      height: calc(100% - @table-head-height);
      white-space: normal;
    }

    .table-body-row {
      min-height: 35px;
      background: #001B3B;

      &:nth-child(2n) {
        background: #003B66;
      }
    }

    .row {
      width: 100%;
      display: flex;
      justify-content: space-between;
    }
    .cell {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
</style>
